import object from 'helpers/object'


export const initialState = {
  services: [],
  isFetching: true,
}


export const setServices = (state, payload) => (
  object.setIn(state, [ 'services' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
